<template>
  <div class="cancellation-container responsive-p">
    <div class="top-header-wrapper">
      <button @click="back" v-if="!isDesktop">
        <img src="@/assets/icons/primary-back.svg" alt="back">
      </button>
      <p class="title">{{ t('cancellation.title') }}</p>
    </div>
    <div class="content-wrapper">
      <p class="description mb-2">{{ t('cancellation.description') }}</p>
      <Radio
        v-for="(reasonItem, index) in reasonList"
        :key="index"
        v-model="selectedReason"
        :label="reasonItem.reason"
        :value="reasonItem.reason"
        class="mb-2 ml-2"
      />
      <MButton @click="submit" :class="`${!isDesktop ? 'mt-a' : 'mt-2'}`">
        {{ t('submit') }}
      </MButton>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useScreenSize } from '@/utils/isDesktop'

import Radio from '@/components/Form/Radio'
import MButton from '@/components/Form/MButton'

export default {
  name: 'cancellationView',
  components: {
    Radio,
    MButton,
  },
  setup() {
    /** context */
    const store = useStore()
    const { t } = useI18n()
    const route = useRoute()
    const router = useRouter()
    const { isDesktop } = useScreenSize()
    const id = route.params.id

    /** reactive */
    const selectedReason = ref(null)

    /** computed */
    const reasonList = computed(() => store.state.order?.cancelReasonList)

    // FIX TASK 2: Detect guest user by checking Vuex auth state
    const getUser = computed(() => store.getters['user/getUser'])

    /** method */
    const back = () => router.back()

    const submit = () => {
      // FIX TASK 2: If logged in → use existing authenticated cancel endpoint.
      // If guest → use new guest cancel endpoint verified by phone number.
      if (getUser.value) {
        // Authenticated user: use existing action
        store.dispatch('order/fetchCancelOrder', { id, reason: selectedReason.value })
      } else {
        // Guest user: get phone from localStorage (stored during guest checkout)
        let phone = ''
        try {
          const userAddress = JSON.parse(localStorage.getItem('userAddress'))
          phone = userAddress?.[0]?.phone || ''
        } catch (e) {
          console.error('Failed to read guest phone:', e)
        }

        if (!phone) {
          store.commit('snackBar/SET_DATA', {
            message: 'ไม่สามารถยกเลิกสิ่งนี้ได้ กรุณาติดต่อเจ้าหน้าที่',
            color: 'warning'
          }, { root: true })
          return
        }

        store.dispatch('order/fetchCancelOrderGuest', {
          id,
          reason: selectedReason.value,
          phone,
        })
      }
    }

    /** mounted */
    onMounted(() => {
      store.dispatch('order/fetchGetCancelReasonList')
    })

    return {
      t,
      back,
      submit,
      reasonList,
      selectedReason,
      isDesktop,
    }
  }
}
</script>

<style lang="scss" scoped>

.cancellation-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  padding-top: 56px;
  @media screen and (min-width: 780px) {
    padding-top: 0;
    padding-bottom: 0;
    height: calc(100% - 74px);
  }
}

.top-header-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-bottom: 1px solid #D6E2EF;
  background-color: var(--white-color);
  position: sticky;
  top: 0;
  z-index: 10;
  flex-shrink: 0;
  @media screen and (min-width: 780px) {
    position: relative;
    border-bottom: 0;
  }
  > button {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-weight: bold;
    font-size: 20px;
    color: var(--secondary-color);
    outline: none;
    background-color: transparent;
    border: 0;
    padding: 8px;
  }
}

.title {
  font-size: 24px;
  font-weight: bold;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  padding: 12px;
  height: 100%;
}

.description {
  font-size: 22px;
}

</style>
